import { gql } from "@apollo/client";

export const GET_DELEGACIONES_BOT = gql`
query GetDelegacionesBOT {
  delegacionesBOT {
    success
    error
    valorEsperado {
      idDelegacion
      descripcion
    }
  }
}`;